const textColor = [
    {
        modeVente: 'Description',
        pastilleColor: 'blue',
        id: 1
    },
    {
        modeVente: 'Avancement',
        pastilleColor: 'purple',
        id: 2

    },
    {
        modeVente: 'Nom du client',
        pastilleColor: 'black',
        id: 3

    },
    {
        modeVente: 'Mode de vente',
        pastilleColor: 'red',
        id: 4

    },
]
const pastilleColor = [
    {
        modeVente: 'Non renseigné',
        pastilleColor: '#9E9E9E',
        id: 5

    },
    {
        modeVente: 'A Livrer',
        pastilleColor: '#FAFF5C',
        id: 6

    },
    {
        modeVente: 'A emporter',
        pastilleColor: '#9090ff',
        id: 7

    },
    {
        modeVente: 'Vente avec service (VAS)',
        pastilleColor: '#FF4A4A',
        id: 8

    },
    {
        modeVente: 'Vente directe',
        pastilleColor: '#5CFFCE',
        id: 9

    },
]



export function LegendWeek() {

    return <div className="containerLegend">
        <div className="legend">
            <h3>Couleur du text :</h3>
            {
                textColor.map((data: any) => (
                    <div key={data.id} className="legendPastille">
                        <p>{data.modeVente}</p>
                        <span className="pastilleLegend" style={{ backgroundColor: data.pastilleColor }}></span>
                    </div>
                ))

            }
        </div>
        <div className="legend">
            <h3>La pastille définie le mode de vente :</h3>
            {
                pastilleColor.map((data: any) => (
                    <div key={data.id} className="legendPastille">
                        <p>{data.modeVente}</p>
                        <span className="pastilleLegend" style={{ backgroundColor: data.pastilleColor }}></span>
                    </div>
                ))
            }
        </div>
    </div>
}